
import LayoutCardSeparator from './LayoutCardSeparator.vue';

const isContainingAllowedTypes = (value) =>
  Array.isArray(value) && value.every((v) => typeof v === 'string' || typeof v === 'number');

export default {
  name: 'BbLayoutCardCaption',
  components: { LayoutCardSeparator },
  props: {
    caption: {
      type: [String, Array],
      default: '',
      validator: (value) => (typeof value === 'string' ? true : isContainingAllowedTypes(value)),
    },
  },
  computed: {
    captions() {
      return Array.isArray(this.caption) ? this.caption : [this.caption];
    },
  },
};
